import { render, staticRenderFns } from "./attr.vue?vue&type=template&id=2e76a0a8&scoped=true&"
import script from "./attr.vue?vue&type=script&lang=js&"
export * from "./attr.vue?vue&type=script&lang=js&"
import style0 from "./attr.vue?vue&type=style&index=0&id=2e76a0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e76a0a8",
  null
  
)

export default component.exports